import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type React from 'react'

interface Props {
  value: boolean
}

export const Content: React.FC<Props> = ({ value }) => (
  <DropdownMenu.Switch id="show_resolved" on={value} title="Show resolved" />
)
